import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { IdentityVerificationModalGqlHelper } from '../../../../../dotcms/dotcms-models/popup/dotcms-verification-popup';
import { useBuildersToProcessGqlData } from '../../../../../dotcms/use-builders-to-process-gql-data';
import { useFetchIssuerDotcmsContentWithDefaultFallback } from '../../../../../dotcms/use-fetch-from-dotcms-with-default-fallback';
import { GlobalLoadingStateOperation } from '../../../global-loading-context/global-loading-context';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { setAuthError } from '../../../../../slices/auth';
import { authSelector } from '../../../../../selectors';

const useVerificationPopup = () => {
  const { createGqlQueryForSingle, processGqlDataAsSingle, contentTypeName } =
    useBuildersToProcessGqlData(IdentityVerificationModalGqlHelper);
  const {
    data,
    loading,
    error: cmsError,
  } = useFetchIssuerDotcmsContentWithDefaultFallback({
    buildGqlSubQuery: createGqlQueryForSingle,
    processResponse: processGqlDataAsSingle,
    loadingStateOperationName:
      GlobalLoadingStateOperation.IDENTITY_VERIFICATION_POPUP_DOTCMS_FETCH,
    contentTypeName,
  });

  const dispatch = useAppDispatch();
  const { error } = useAppSelector(authSelector);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (error === 'verifyUnable') {
      setDialogOpen(true);
    } else {
      setDialogOpen(false);
    }
  }, [error]);

  const handleOnClose = useCallback(() => {
    dispatch(setAuthError(''));
  }, [dispatch]);

  return useMemo(
    () => ({
      dialogData: data?.identityVerificationPopup,
      dialogOpen,
      loading,
      cmsError,
      handleOnClose,
    }),
    [data, dialogOpen, loading, cmsError, handleOnClose],
  );
};

export default useVerificationPopup;
